import { SvgIcon, SvgIconProps } from "@mui/material";

export const TwoChatBubbleIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.609 9.5V5.435A2.435 2.435 0 0 0 15.174 3H5.435A2.435 2.435 0 0 0 3 5.435v6.696a2.435 2.435 0 0 0 2.435 2.435h1.217V17L9 15.435"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 19h-4a2 2 0 0 1-2-2v-5.5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2h-1v2l-3-2Z" clip-rule="evenodd"/></svg>
  </SvgIcon>
);
